// Stub из дизайна mp-admin-preprod-2026-05-17 / reception.jsx — карточка
// «Курьеры» помечена `soon: true` и показывает мок-данные (3 курьера +
// таблица заявок на день). Реальный функционал (входящие грузы от
// курьерских компаний из РФ с AI-парсингом) временно отложен и лежит в
// CouriersSubscreen.full.tsx.bak — вернётся после launch (см. плана
// docs/plans/2026-05-21-admin-design-realign.md Task 2 + Open scope).

type Courier = {
  name: string;
  role: 'Забор' | 'Доставка';
  status: 'on-route' | 'busy' | 'free';
  count: number;
};

type Job = {
  time: string;
  type: 'Забор' | 'Доставка';
  address: string;
  orderId: string;
  courier: string;
  statusLabel: string;
  statusTone: 'green' | 'gray' | 'amber' | 'red' | 'blue';
};

const COURIERS: Courier[] = [
  { name: 'Гиорги', role: 'Забор', status: 'on-route', count: 4 },
  { name: 'Дато', role: 'Доставка', status: 'free', count: 0 },
  { name: 'Леван', role: 'Забор', status: 'busy', count: 7 },
];

const JOBS: Job[] = [
  { time: '14:00', type: 'Забор', address: 'Сабуртало, пр. Важа Пшавела 23', orderId: '#1244', courier: 'Гиорги', statusLabel: 'В пути', statusTone: 'green' },
  { time: '14:30', type: 'Доставка', address: 'Ваке, ул. Чавчавадзе 12', orderId: '#1240', courier: 'Гиорги', statusLabel: 'Назначен', statusTone: 'gray' },
  { time: '15:00', type: 'Забор', address: 'Глдани, мкр. 4, дом 18', orderId: '#1242', courier: 'Леван', statusLabel: 'Опаздывает', statusTone: 'amber' },
  { time: '16:00', type: 'Доставка', address: 'Дидубе, ул. Зестафони 5', orderId: '#1239', courier: '—', statusLabel: 'Не назначен', statusTone: 'red' },
];

function statusBadge(s: Courier['status'], count: number): { label: string; tone: 'green' | 'amber' | 'gray' } {
  if (s === 'on-route') return { label: `В пути · ${count}`, tone: 'green' };
  if (s === 'busy') return { label: `Загружен · ${count}`, tone: 'amber' };
  return { label: `Свободен · ${count}`, tone: 'gray' };
}

export function CouriersSubscreen() {
  return (
    <div className="reception-stub" data-testid="couriers-stub">
      <header className="reception-stub-head">
        <h2 className="cb-h2">Курьеры</h2>
        <p className="cb-h2-sub">Забор и доставка — ставка на сегодня</p>
        <span className="badge-a yellow" style={{ marginLeft: 8, verticalAlign: 'middle' }}>В разработке</span>
      </header>

      <div className="reception-stub-grid-3">
        {COURIERS.map((c) => {
          const badge = statusBadge(c.status, c.count);
          return (
            <article key={c.name} className="courier-card">
              <div className="courier-avatar">{c.name[0]}</div>
              <div style={{ flex: 1 }}>
                <p className="courier-name">{c.name}</p>
                <p className="courier-role">{c.role}</p>
              </div>
              <span className={`badge-a ${badge.tone}`}>{badge.label}</span>
            </article>
          );
        })}
      </div>

      <section className="panel" style={{ marginTop: 16 }}>
        <header className="panel-head">
          <p className="panel-title">Заявки на сегодня</p>
        </header>
        <table className="data">
          <thead>
            <tr>
              <th>Время</th>
              <th>Тип</th>
              <th>Адрес</th>
              <th>Заказ</th>
              <th>Курьер</th>
              <th>Статус</th>
            </tr>
          </thead>
          <tbody>
            {JOBS.map((j, i) => (
              <tr key={i}>
                <td>{j.time}</td>
                <td>
                  <span className={`badge-a ${j.type === 'Забор' ? 'blue' : 'green'}`}>{j.type}</span>
                </td>
                <td className="muted">{j.address}</td>
                <td className="mono">{j.orderId}</td>
                <td>{j.courier}</td>
                <td>
                  <span className={`badge-a ${j.statusTone}`}>{j.statusLabel}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </div>
  );
}
